<div
    [id]="id"
    class="agpr-actionChip"
>
    <span class="agpr-actionChipIcon" [ngClass]="action.icon" aria-hidden="true"></span>
    <span class="agpr-actionChipLabel">
        {{ 'AutomationAgents.action.card.' + action.type | localize }}{{ action.detailLabel ? ':' : '' }}
    </span>
    @if (action.detailLabel) {
        @if (canViewActionTarget) {
            <!-- One link per target, since an action can save to several folders or tags -->
            @for (target of action.targets; track target.id) {
                @if (!$first) {
                    <span class="agpr-actionChipSeparator">,&nbsp;</span>
                }
                <a
                    [id]="id + '_link_' + $index"
                    class="agpr-actionChipDetail agpr-actionChipDetail--link"
                    (click)="viewActionTarget.emit(target.id)"
                    tabindex="0"
                    [agprTooltip]="'View ' + target.name"
                >{{ target.name }}</a>
            }
        } @else {
            <span class="agpr-actionChipDetail">{{ action.detailLabel | localize }}</span>
        }
    }
</div>